
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/LVUSD",
      function () {
        return require("private-next-pages/LVUSD.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/LVUSD"])
      });
    }
  